import Todo from './components/Todos'
function App() {
  return (
    <div className="App">
        <Todo />
    </div>
  );
}

export default App;
